
//const api_base = "http://localhost:24321"
//const api_base = "https://uat-api.smart-q.com"
//pattaya
//const api_base = "https://backendappointment.pattayaconnect.net"
//prd
const api_base = "https://api.smart-q.com"

module.exports = {
    /*title : '9MANAD DEV RESERVATION',
    custompage : {
        '0' : {
            '1' : {
                page : 'date'
                ,group : 1
            },
            '2' : {
                page : 'group'
                ,group_list : [2,3]
            }
        }
    },
    register_callback : {
        '0' : 'https://www.google.co.th/'
    },*/
    //title : '9MANAD UAT RESERVATION',
    //title : 'PATTAYA CONNECT RESERVATION',
	title : '9MANAD RESERVATION',
    custompage : {
        '5' : {
            '1' : {
                page : 'date'
                ,group : 14
            },
            '2' : {
                page : 'group'
                ,group_list : [15,16,17]
            }
        }
    },
    register_callback : {
        '11' : 'https://outlook.office365.com/owa/calendar/UthaithaniImmigrationOffice@imm5division.onmicrosoft.com/bookings/'
    },

    api : {
        url : {
            public : {
                line : {
                    login : api_base + '/public/line/login'
                    ,register : api_base + '/public/line/register'
                    ,get_appconfig : api_base + '/public/line/get/appconfig'
                    ,get_liff : api_base + '/public/line/get/liff'
                },
                station : {
                    get_stationshortdetail : api_base + '/public/station/get/stationshortdetail'
                    ,get_registerform : api_base + '/public/station/get/registerform'
                },
                appointment : {
                    get_stationmap : api_base + '/public/appointment/get/stationmap'
                    ,get_grouplist : api_base + '/public/appointment/get/grouplist'
                    ,get_calendar : api_base + '/public/appointment/get/calendar'
                    ,get_timeslot : api_base + '/public/appointment/get/timeslot'
                    ,get_groupshortdetail : api_base + '/public/appointment/get/groupshortdetail'
                    ,get_groupextranotelist : api_base + "/public/appointment/get/groupextranotelist"
                },
                queue : {
                    get_queuedetail : api_base + '/public/queue/get/queuedetail'
                    ,get_queuegroup : api_base + '/public/queue/get/queuegroup'
                    ,get_stationdetail : api_base + '/public/queue/get/stationdetail'
                }
            },
            line : {
                station : {
                    register : api_base + '/line/station/register'
                    ,get_stationmemberstatus : api_base + '/line/station/get/stationmemberstatus'
                    ,get_stationmembermeetform : api_base + '/line/station/get/stationmembermeetform'
                    ,get_stationmemberform : api_base + '/line/station/get/stationmemberform'
                    ,get_stationmemberula : api_base + '/line/station/get/stationmemberula'
                    ,accept_ula : api_base + '/line/station/accept/ula'
                },
                appointment : {
                    get_welcomestatus : api_base + '/line/appointment/get/welcomestatus'
                    ,get_activatelist : api_base + '/line/appointment/get/activatelist'
                    ,activate : api_base + '/line/appointment/activate'
                    ,new_confirm : api_base + '/line/appointment/new/confirm'
                    ,manage : {
                        get_appointmentlist : api_base + '/line/appointment/manage/get/appointmentlist'
                        ,edit_status : api_base + '/line/appointment/manage/edit/status'
                    }
                }
                ,queue : {
                    tracking_queue : api_base + '/line/queue/tracking/queue'
                    ,add_cmd : api_base + '/line/queue/add/cmd'
                    ,get_lastqueue : api_base + '/line/queue/get/lastqueue'
                    ,get_managestatus : api_base + '/line/queue/get/managestatus'
                    ,get_managequeuelist : api_base + '/line/queue/get/managequeuelist'
                    ,edit_stationname : api_base + '/line/queue/edit/stationname'
                    ,edit_queueannouncement : api_base + '/line/queue/edit/queueannouncement'
                    ,edit_queueurl : api_base + '/line/queue/edit/queueurl'
                    ,edit_queueenable : api_base + '/line/queue/edit/queueenable'
                    ,edit_queuegroup : api_base + '/line/queue/edit/queuegroup'
                }
                ,specialmarket : {
                    get_price : api_base + '/line/special/market/get/price'
                    ,order : api_base + '/line/special/market/order'
                    ,get_lastinput : api_base + '/line/special/market/get/lastinput'
                    ,get_ordermeta : api_base + '/line/special/market/get/ordermeta'
                    ,get_orderlist : api_base + '/line/special/market/get/orderlist'
                    ,get_orderdetail : api_base + '/line/special/market/get/orderdetail'
                }
            }
        }
    }
}